import type { SceneModule } from '../_shared/types'
import ChatStory from './ChatStory'
import { ChatStoryEditor } from './Editor'
import { render } from './svgRender'
import { ChatStoryComposition } from './Composition'

export const module: SceneModule = {
  id: 'chat-story',
  Component: ChatStory,
  Composition: ChatStoryComposition,
  Editor: ChatStoryEditor,
  svgRender: render,
}
